import {RRRoadBookType} from "./RRRoadBookType";

export const roadBookFBConverter = {
    fromFirestore: (snapshot: any, options: any): RRRoadBookType => {
        const data = snapshot.data(options);
        // convert Firestore Timestamps to JS Date if present
        const createdAt = data.createdAt && data.createdAt.toDate ? data.createdAt.toDate() : (data.createdAt instanceof Date ? data.createdAt : undefined);
        const updatedAt = data.updatedAt && data.updatedAt.toDate ? data.updatedAt.toDate() : (data.updatedAt instanceof Date ? data.updatedAt : undefined);
        return {
            id: snapshot.id,
            employeeId: data.employeeId,
            employeeName: data.employeeName || '',
            date: data.date.toDate(),
            formNumber: (data.formNumber !== undefined && data.formNumber !== null) ? Number(data.formNumber) : undefined,
            vehiclePlate: data.vehiclePlate || '',
            startKm: data.startKm ?? null,
            endKm: data.endKm ?? null,
            rows: data.rows || [],
            createdAt,
            updatedAt
        } as RRRoadBookType;
    },
    toFirestore: (roadbook: RRRoadBookType) => {
        const out: any = {
            employeeId: roadbook.employeeId,
            employeeName: roadbook.employeeName || '',
            date: roadbook.date,
            formNumber: roadbook.formNumber != null ? Number(roadbook.formNumber) : null,
            vehiclePlate: roadbook.vehiclePlate || '',
            startKm: roadbook.startKm ?? null,
            endKm: roadbook.endKm ?? null,
            rows: roadbook.rows || []
        };

        // Preserve createdAt if provided (update), otherwise set to current Date
        if (roadbook.createdAt !== undefined && roadbook.createdAt !== null) {
            out.createdAt = roadbook.createdAt instanceof Date ? roadbook.createdAt : new Date(roadbook.createdAt as any);
        } else {
            out.createdAt = new Date();
        }
        // Always set updatedAt to current Date
        out.updatedAt = new Date();

        return out;
    }
}
